export default __webpack_public_path__ + "static/media/heart.1aad35eb.mp3";